<template>
  <div>
    <commonupdata>
      <span class="title">修改密码</span>
      <a-form ref="form" :autoFormCreate="(form)=>{this.form = form}" id="form">
        <a-form-item
          fieldDecoratorId="password"
          :fieldDecoratorOptions="{rules: [{ required: true, message: '至少6位密码'},{min:6,message: '至少6位密码'}]}"
        >
          <a-input size="large" type="password" autocomplete="false" placeholder="请输入至少6位密码">
            <a-icon slot="prefix" type="lock"></a-icon>
          </a-input>
        </a-form-item>
        <a-form-item
          fieldDecoratorId="password2"
          :fieldDecoratorOptions="{rules: [{ required: true, message: '至少6位密码' }, { validator: this.handlePasswordCheck }]}"
        >
          <a-input size="large" type="password" autocomplete="false" placeholder="确认密码">
            <a-icon slot="prefix" type="lock"></a-icon>
          </a-input>
        </a-form-item>
        <div class="foot-btn">
          <a-button class="commitbtn" block size="large" @click.stop.prevent="onHandleSubmit">确认</a-button>
          <a-button class="canceltbtn" block size="large" @click="onCancel">取消</a-button>
        </div>
      </a-form>
    </commonupdata>
  </div>
</template>
<script>
import commonupdata from "../common/LoginComm";
import { mapState } from "vuex";
export default {
  data() {
    return {
      // passwordLevelChecked: false,
    };
  },
  components: {
    commonupdata
  },
  computed: {
    ...mapState({
      userName: state => state.findpassword.userName,
      verificationCode: state => state.findpassword.verificationCode,
      tenantName: state => state.findpassword.tenantName
    })
  },
  methods: {
    onHandleSubmit() {
      this.form.validateFields((err, values) => {
        if (!err) {
          let password = this.form.getFieldValue("password");
          this.$put("user/forgetPassword", {
            tenantName: this.tenantName,
            userName: this.userName,
            verificationCode: this.verificationCode,
            password: password
          })
            .then(r => {
              this.successTip("success");
              this.returnLogin();
              sessionStorage.clear()
            })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    },
    handlePasswordCheck(rule, value, callback) {
      let password = this.form.getFieldValue("password");
      /* if (value === undefined) {
        callback(new Error("请输入密码"));
      } */
      if (value && password && value.trim() !== password.trim()) {
        callback(new Error("两次密码不一致"));
      }
      callback();
    },
    isMobile() {
      return this.$store.state.setting.isMobile;
    },
    /* handlePasswordInputClick() {
      if (!this.isMobile()) {
        this.state.passwordLevelChecked = true;
        return;
      }
      this.state.passwordLevelChecked = false;
    }, */
    handlePasswordLevel(rule, value, callback) {
      let level = 0;

      // 判断这个字符串中有没有数字
      if (/[0-9]/.test(value)) {
        level++;
      }
      // 判断字符串中有没有字母
      if (/[a-zA-Z]/.test(value)) {
        level++;
      }
      // 判断字符串中有没有特殊符号
      if (/[^0-9a-zA-Z_]/.test(value)) {
        level++;
      }
      this.state.passwordLevel = level;
      this.state.percent = level * 30;
      if (level >= 2) {
        if (level >= 3) {
          this.state.percent = 100;
        }
        callback();
      } else {
        if (level === 0) {
          this.state.percent = 10;
        }
        callback(new Error("请输入含字母和数字的密码"));
      }
    },
    successTip(type) {
      this.$notification[type]({
        message: "密码修改成功",
        description: "已成功修改密码，请使用新密码重新登录"
      });
    },
    returnLogin() {
      console.log('登陆')
      this.$router.go(-2)
    },
    onCancel() {
      this.$router.back(-1);
    }
  },
  beforeRouteEnter: (to, from, next) => {
    console.log("from", from.name);
    if (from.name == "findpassword") {
      next();
    } 
  },
};
</script>
<style lang="less" scoped>
.title {
  display: inline-block;
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 20px;
  margin-top: 20px;
}
.foot-btn {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .commitbtn {
    width: 170px;
    border-color: #40a9ff;
    color: #40a9ff;
  }
  .canceltbtn {
    width: 80px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/findpassword/updatepassword.vue